<template>
  <div
    class="confirm-create-container"
    :hide-overlay="true"
  >
    <button
      type="button"
      class="btn btn--orange"
      id="create_tender"
      slot="activator"
      @click="openModal()"
    >{{ $t('action.newTender') }}</button>
    <modal
      ref="modal"
      :showCloseBtn="false"
      :modalId="`confirm-create-${+new Date()}`"
    >
      <div
        id="confirm-create-container"
        class="modal-container"
      >
        <p class="confirm-header">{{ $t('hint.draftType') }}</p>
        <p class="msg_hint">Choose a Type</p>
        <HKLSelect
          :value="draftType || undefined"
          :options="draftTypeHklOptions"
          :showSearch="true"
          placeholder=""
          @change="draftType = $event || ''"
        />
        <span
          id="hint"
          v-if="hint"
          class="alert alert--error"
        >{{ hint }}</span>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeModal()"
        >{{ $t('action.cancel') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          @click="goCreate(draftType)"
        >{{ $t('action.enter') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/controls/Modal'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import HTTP from '@/utils/http'
import navigation from '@/utils/navigation'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmCreate',
  components: {
    Modal,
    HKLSelect,
  },
  data () {
    const options = ['ITQ', 'Tender']
    return {
      prNumber: '',
      hint: '',
      draftType: options[0],
      options,
    }
  },
  methods: {
    openModal () {
      this.$refs.modal.open()
    },
    closeModal () {
      this.$refs.modal.close()
    },
    handleResponse (id, routerName) {
      this.closeModal()
      navigation.toPage(routerName, { id })
    },

    async goCreate (draftType) {
      const createdBy = this.currentUser.id
      const managedBy = createdBy
      const reqJSON = {
        general: { tenderType: draftType.toUpperCase(), createdBy, managedBy },
      }
      // TODO extract the HTTP call to state
      await HTTP.post('/tenders', reqJSON)
        .then((resp) => {
          this.handleResponse(resp.data.data.id, 'tenderDetails')
        })
        .catch(() => {
          this.hint = this.$i18n.t('error.system')
        })
    },
  },
  computed: {
    ...mapGetters('user', ['currentUser']),
    draftTypeHklOptions () {
      return this.options.map((value) => ({
        name: value,
        value,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/confirmCreate';
@import '~styles/popup';
</style>
